import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameSubForm, Schema as NameSchema } from '../subforms/Name';
import { ContactSubForm, Schema as ContactSchema } from '../subforms/Contact';
import { CitySubForm, Schema as CitySchema } from '../subforms/City';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';
import { DocumentsStandardSubForm, Schema as DocumentsStandardSchema } from '../subforms/DocumentsStandard';

export const StadtwerkeSpeyerAzubiSchema = (settings) => (
    Yup.object()
        .concat(NameSchema(settings))
        .concat(ContactSchema(settings))
        .concat(CitySchema(settings))
        .concat(OtherInformationSchema(settings))
        .concat(DocumentsStandardSchema(settings))
);

export const StadtwerkeSpeyerAzubi = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={NameSubForm} colors={colors} settings={settings} />
            <Field component={ContactSubForm} colors={colors} settings={settings} />
            <Field component={CitySubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsStandardSubForm} colors={colors} settings={settings} />
        </>
    );
}